import api, { type AxiosResponse } from './client';

/** A file copied from the site's ERP document store (today: FAIR reports). */
export interface ERPDocument {
  id: number;
  /** What the file is, e.g. "FAIR report". */
  kind: string;
  file_name: string;
  /** Bytes. */
  size: number;
  job_number: string;
  fair_number: string;
  /** When it was uploaded in the ERP. */
  erp_created_at: string | null;
}

/** ERP files (FAIR reports) on a PO line. Same feature switch and scoping as the CofC. */
export const erpDocumentsAPI = {
  /** The FAIR reports the ERP holds for this line's jobs. */
  listForLine: (lineId: number): Promise<AxiosResponse<ERPDocument[]>> =>
    api.get(`/purchasing/lines/${lineId}/erp-documents/`),

  /** One of those files, as a blob to open in a new tab. */
  getFile: (lineId: number, documentId: number): Promise<AxiosResponse<Blob>> =>
    api.get(`/purchasing/lines/${lineId}/erp-documents/${documentId}/`, { responseType: 'blob' }),
};
